class Customer {
	firstName = '';

	surname= '';

	email = '';

	phoneNumber = '';

	vatNumber = null;

	address = null;

	constructor({
		firstName = '',
		surname = '',
		email = '',
		phoneNumber = '',
		vatNumber = '',
		address = { address: '', countryCode: '', city: '' },
	}) {
		this.firstName = firstName;
		this.surname = surname;
		this.email = email;
		this.phoneNumber = phoneNumber;
		this.vatNumber = vatNumber;
		this.address = address;
	}
}

export default Customer;
